export default __webpack_public_path__ + "static/media/location-pin.2573bdc4.svg";